(function () {
    function initTimeline() {
        var position = 1;
        var timelineBase = document.getElementById('timeline-base');
        window.theme.utils.swipe(timelineBase, function (swipedir) {
            switch (swipedir) {
                case 'left':
                    nextDate();
                    break;
                case 'right':
                    prevDate();
                    break;
            }
        });
        function nextDate() {
            if (position === 3) return;
            position++;
            timelineBase.dataset.timeline = position;
        }
        function prevDate() {
            if (position === 1) return;
            position--;
            timelineBase.dataset.timeline = position;
        }
        function setDate(n) {
            if (position === n) return;
            position = n;
            timelineBase.dataset.timeline = position;
        }
        function changeDate(e) {
            var el = e.target;
            if (el.dataset.direction === 'right') nextDate();
            else if (el.dataset.direction === 'left') prevDate();
            else setDate(parseInt(el.dataset.position));
        }
        document.querySelectorAll(".timeline-button, .tl-arrow").forEach(function (button) { button.addEventListener("click", changeDate); });
    }
    document.addEventListener('DOMContentLoaded', initTimeline);
})()

